import React from 'react';
import InputV1 from '../../../components/ComponentsV1/InputV1';
import { Mail } from 'lucide-react';
import Button from '../../../components/ComponentsV1/Button';
import { Smartphone } from 'lucide-react';
import { KeyRound } from 'lucide-react';

const FormContent = ({
  step,
  email,
  validateEmail,
  isValidEmail,
  loading,
  getOtp,
  getTOtp,
  validateOTP,
  isValidOTP,
  submitOtp,
  totp,
  validateTOTP,
  isValidTOTP,
  submitTOtp,
  otp,
}) => {
  /* EMAIL FORM */
  if (step === 'email') {
    return (
      <>
        <div className='tw-flex-col tw-gap-4 tw-mb-6'>
          <InputV1
            searchIcon={
              <Mail
                size={15}
                className='tw-mx-2 tw-text-grey-500'
                strokeWidth={1.3}
              />
            }
            placeholder='Enter email ID'
            value={email}
            onChange={(val) => validateEmail(val)}
            inputClassName='tw-w-full tw-h-[4.5rem] !tw-bg-white'
          />
        </div>

        <div className='tw-w-full tw-h-full'>
          <Button
            title={
              <div className='tw-flex tw-items-center tw-justify-center tw-w-full'>
                <Mail
                  size={15}
                  className='tw-mr-3 tw-text-white'
                  strokeWidth={2}
                />
                Email OTP
              </div>
            }
            disabled={!isValidEmail || loading}
            onClick={getOtp}
            size='large'
            className={'tw-w-full tw-mr-6 !tw-duration-0 !tw-transition-none'}
          />

          <Button
            title={
              <div className='tw-flex tw-items-center tw-justify-center tw-w-full'>
                <Smartphone
                  size={15}
                  className='tw-mr-3 tw-text-white'
                  strokeWidth={2}
                />
                Auth App
              </div>
            }
            disabled={!isValidEmail}
            className={'tw-w-full !tw-duration-0 !tw-transition-none'}
            size='large'
            onClick={getTOtp}
          />
        </div>
      </>
    );
  }

  /* OTP FORM */
  if (step === 'otp') {
    return (
      <>
        <div className='tw-flex-col tw-gap-4 tw-mb-6'>
          <InputV1
            searchIcon={
              <KeyRound
                size={15}
                className='tw-mx-2 tw-text-grey-500'
                strokeWidth={1.3}
              />
            }
            placeholder='Enter OTP to verify'
            value={otp}
            onChange={(val) => validateOTP(val)}
            inputClassName='tw-w-full tw-h-[4.5rem] !tw-bg-white'
          />
        </div>

        <div className='tw-w-full tw-h-full'>
          <Button
            title={
              <div className='tw-flex tw-items-center tw-justify-center tw-w-full'>
                Submit
              </div>
            }
            disabled={!isValidOTP || loading}
            className={'tw-w-full !tw-duration-0 !tw-transition-none'}
            size='large'
            onClick={submitOtp}
          />
        </div>
      </>
    );
  }

  /* TOTP FORM */
  if (step === 'totp') {
    return (
      <>
        <div className='tw-flex-col tw-gap-4 tw-mb-6'>
          <InputV1
            searchIcon={
              <KeyRound
                size={15}
                className='tw-mx-2 tw-text-grey-500'
                strokeWidth={1.3}
              />
            }
            placeholder='Enter Code from Auth App'
            value={totp}
            onChange={(val) => validateTOTP(val)}
            inputClassName='tw-w-full tw-h-[4.5rem] !tw-bg-white'
          />
        </div>

        <div className='tw-w-full tw-h-full'>
          <Button
            title={
              <div className='tw-flex tw-items-center tw-justify-center tw-w-full'>
                Submit
              </div>
            }
            disabled={!isValidTOTP || loading}
            className={'tw-w-full !tw-duration-0 !tw-transition-none'}
            size='large'
            onClick={submitTOtp}
          />
        </div>
      </>
    );
  }

  return <div />;
};

export default FormContent;
